import React from "react";
import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import {
  FiHome,
  FiLayout,
  FiBarChart2,
  FiCalendar,
  FiBell,
  FiUser,
  FiFolder,
} from "react-icons/fi";

const ParentSidebar: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="sidebar enhanced-sidebar">
      <div className="sidebar-header">
        <img src="/logo.png" alt="Serene Minds Logo" className="sidebar-logo" />
      </div>

      <ul className="sidebar-list">
        <li className={isActive("/parent/dashboard") ? "active" : ""}>
          <FiHome className="icon" />
          <Link to="/parent/dashboard">Dashboard</Link>
        </li>
        <li className={isActive("/parent/wellbeing") || location.pathname.startsWith("/parent/wellbeing/") ? "active" : ""}>
          <FiLayout className="icon" />
          <Link to="/parent/wellbeing">Wellbeing Analysis</Link>
        </li>
        <li className={isActive("/parent/insights") ? "active" : ""}>
          <FiBarChart2 className="icon" />
          <Link to="/parent/insights">Category Insights</Link>
        </li>
        <li className={isActive("/parent/calendar") ? "active" : ""}>
          <FiCalendar className="icon" />
          <Link to="/parent/calendar">Calendar</Link>
        </li>
        <li className={isActive("/parent/events") ? "active" : ""}>
          <FiFolder className="icon" />
          <Link to="/parent/events">Events</Link>
        </li>
        <li className={isActive("/parent/notifications") ? "active" : ""}>
          <FiBell className="icon" />
          <Link to="/parent/notifications">
            Notifications
          </Link>
        </li>
        <li className={isActive("/parent/profile") ? "active" : ""}>
          <FiUser className="icon" />
          <Link to="/parent/profile">My Profile</Link>
        </li>
      </ul>
    </div>
  );
};

export default ParentSidebar;

